/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateReportRequest } from '../../models/create-report-request';
import { CropReport } from '../../models/crop-report';

export interface TriggerCropReportCreation$Params {
      body: CreateReportRequest
}

export function triggerCropReportCreation(http: HttpClient, rootUrl: string, params: TriggerCropReportCreation$Params, context?: HttpContext): Observable<StrictHttpResponse<CropReport>> {
  const rb = new RequestBuilder(rootUrl, triggerCropReportCreation.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CropReport>;
    })
  );
}

triggerCropReportCreation.PATH = '/api/cropreport';
